var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("인사말")])]), _c('v-row', {
    staticClass: "row--xl"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "724",
      "src": "/images/about/greeting/group.webp",
      "alt": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('v-card', {
    staticClass: "text-content",
    attrs: {
      "tile": "",
      "flat": "",
      "min-height": "430",
      "img": "/images/about/greeting/bg-logo.png"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 778 / 519
    }
  }, [_c('div', {
    staticClass: "page-text page-text--lg"
  }, [_c('p', [_vm._v(" 위드캔복지재단은 "), _c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("“사람 중심의 복지, 더 나은 세상을 향해”")]), _vm._v("라는 미션 아래, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 모든 이웃이 차별 없이 존엄한 삶을 누릴 수 있도록 노력하고 있습니다. ")]), _c('br'), _c('p', [_vm._v(" 1989년 설립 이후, 국내외 취약계층을 위한 생애주기별 맞춤형 복지사업과 국제협력 프로그램을 통해 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 지속 가능한 변화를 추구해 왔습니다. 이러한 노력은 여러분의 지속적인 관심과 참여 덕분에 가능했습니다. ")]), _c('br'), _c('p', [_vm._v(" 앞으로도 저희 위드캔복지재단은 전문성과 혁신을 바탕으로 포용적이고 지속 가능한 복지 서비스를 제공하며, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 나눔과 협력의 가치를 실천하겠습니다. 함께 성장하는 더 나은 미래를 만들어가기 위해 여러분의 따뜻한 관심과 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 참여를 부탁드립니다. ")]), _c('br'), _c('p', [_vm._v("감사합니다")])])]), _c('div', {
    staticClass: "from page-text page-text--lg line-height-1 grey-1--text font-weight-bold"
  }, [_vm._v("위드캔복지재단 대표이사 이 종 화")])], 1)], 1)], 1)], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }